import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/cashier';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/orders`, payload);
};

const listExport = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/orders/export`, payload, {
		responseType: 'blob',
	});
};

export default {
	list,
	listExport,
};
